"use strict";

module.exports = function (accumulator, order, product, component) {
  var addition = component.paper;

  if (accumulator.length) {
    return accumulator + ' ' + addition;
  }

  return accumulator + addition;
};